export const defaultTheme = {
    spacing: {
        extraLarge: '70px',
        large: '40px',
        main: '30px',
        small: '20px'
    },
    colors: {
        black: '#000',
        gray: {
            main: '#CCCCCC',
            input: '#979797',
        },
        green: {
            main: '#3f035b',
        },
        red: {
            main: '#F15155',
        },
        gradient: {
            teal: '-webkit-linear-gradient(#00BF58, #00A8BF)',
            category: '-webkit-linear-gradient(#451d58, #3f035b)',
        },

    },
}